import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { ResetpasswordService } from '@app/services/resetpassword.service';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetpasswordComponent implements OnInit {
  responsemessage: string;
  memberform;
 

  constructor(
    private fb: FormBuilder,
    private resetpasswordService: ResetpasswordService,
    private router: Router) {
  }

  ngOnInit(): void {
    this.memberform = this.fb.group({
      memberid: ['', Validators.required]
    });
  }
  
  send() {
    this.resetpasswordService.SendPasswordResetEmailAsync(+this.memberform.get('memberid').value).subscribe(response => {
      this.responsemessage = response.toString();
    });
  }

  home() {
    this.router.navigate(['']);
  }
}
